import React, { createContext, useContext, useMemo, useState } from 'react';
import { type AppSettings } from './api/types.js';

interface SettingsContextType {
  settings: AppSettings | null;
  setSettings: React.Dispatch<React.SetStateAction<AppSettings | null>>;
}

const SettingsContext = createContext<SettingsContextType | null>(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState<AppSettings | null>(null);

  // Wrap the value in useMemo to prevent unnecessary re-renders
  // of all consumers whenever the parent re-renders
  const value = useMemo(
    () => ({
      settings,
      setSettings, // Passing the setter function here
    }),
    [settings]
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) throw new Error('useSettings must be used within SettingsProvider');
  return context;
}
